import { ZoomPhoneRecordingApiService } from '@/api/user/resources/zoom_phone_recording';
import store from '@/store/index';
import { TCallConnectedEventData, TCallEndedEventData, TCallRingingEventData, TEventData, TCallRecordingCompletedEventData } from './zoom_phone_types';

// 設定系

const zoomPhoneContainer = () => document.querySelector<HTMLIFrameElement>('iframe#zoom-embeddable-phone-iframe');
const zoomPhone = () => zoomPhoneContainer().contentWindow;

const initZoomPhone = (): void => {
  window.removeEventListener('message', handleEvents);
  window.addEventListener('message', handleEvents);
};

/**
 * 発着信
 */
const handleCallRinging = (data: TCallRingingEventData): void => {
  const { callId: id, direction, dateTime: startedAt } = data;
  store.dispatch('zoomPhone/setCallStartedInfoAction', { id, direction, startedAt });
};

/**
 * call connected
 */
const handleCallConnected = (data: TCallConnectedEventData): void => {
  const { callId: id, direction, dateTime: connectedAt } = data;
  store.dispatch('zoomPhone/setCallConnectedInfoAction', { id, direction, connectedAt });
};

/**
 * call終了
 */
const handleCallEnded = (data: TCallEndedEventData): void => {
  const { callId: id, direction, dateTime: endedAt, result } = data;
  store.dispatch('zoomPhone/setCallEndedInfoAction', { id, direction, endedAt, result });
};

/**
 * 音声ファイル準備完了
 */
const handleCallRecordingCompleted = async (data: TCallRecordingCompletedEventData) => {
  const { callId } = data;
  const zoomPhoneRecordingApiService = new ZoomPhoneRecordingApiService();
  await zoomPhoneRecordingApiService.downloadZoomPhoneRecording({
    request: {
      downloadZoomPhoneRecordingRequest: {
        callId,
      },
    },
  });
};

/**
 * event handle（分岐）
 */
const handleEvents = (e: MessageEvent<TEventData>) => {
  if (!e.data) return;

  const { type, data } = e.data;
  switch (type) {
    case 'zp-call-ringing-event': // 発信・着信時
      handleCallRinging(data as TCallRingingEventData);
      break;
    case 'zp-call-connected-event': // call connected
      handleCallConnected(data as TCallConnectedEventData);
      break;
    case 'zp-call-ended-event': // call終了
      handleCallEnded(data as TCallEndedEventData);
      break;
    case 'zp-call-recording-completed-event': // 音声ファイル準備完了
      handleCallRecordingCompleted(data as TCallRecordingCompletedEventData);
      break;
  }
};

// 呼び出し

/**
 * 発信
 */
// FIXME: 一次対応としてタイムアウトエラーを無効化している(https://smartcamp.slack.com/archives/CKLP8H75M/p1773637011651439)
// const makeCall = (phoneNumber: string, onFailed: () => void): void => {
const makeCall = (phoneNumber: string): void => {
  // NOTE: この時点で「通話中」にする
  store.dispatch('zoomPhone/setOutboundCallingAction');

  // FIXME: 一次対応としてタイムアウトエラーを無効化している(https://smartcamp.slack.com/archives/CKLP8H75M/p1773637011651439)
  // NOTE: 5秒経過しても発信がされない場合は、失敗とみなす。
  // const timeout = setTimeout(() => {
  //   if (store.getters['zoomPhone/hasCallInfo']) return;
  //   store.dispatch('zoomPhone/resetOutboundCallingAction');
  //   onFailed();
  // }, 5000);

  // // NOTE: これが必要となるのは、5秒以内に「発信 -> 通話完了 -> 発信」が行われたケースくらいと思われる。
  // //       そのため現実的にはなくてもよさそうではある。
  // //       ただし、一応ロジック上は存在するパターンのため、いれておく。
  // window.addEventListener('message', (e: MessageEvent<TEventData>) => {
  //   if (e.data.type === 'zp-call-ringing-event') {
  //     clearTimeout(timeout);
  //   }
  // }, { once: true });

  zoomPhone().postMessage({
    type: 'zp-make-call',
    data: { number: phoneNumber, autoDial: false },
  }, 'https://applications.zoom.us');
};

export {
  initZoomPhone,
  makeCall,
};
